import { fade } from "@material-ui/core/styles/colorManipulator";

export default (theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
  },

  grow: {
    flexGrow: 1,
  },
  appbarTransparent: {
    background: "transparent",
    boxShadow: "none",
    zIndex: 1000,
  },

  heroContainer: {
    height: "100%",
  },
  heroTitle: {
    color: "white",
    // fontSize: "50px",
  },
});
